import { render, staticRenderFns } from "./relatorio-recebimentos-recepcao.vue?vue&type=template&id=37e9c3e0"
import script from "./relatorio-recebimentos-recepcao.vue?vue&type=script&lang=js"
export * from "./relatorio-recebimentos-recepcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports